/* eslint-disable */
export function getClearCodesArray(codes) {
  return codes
    .replace(/[\s\,\;]+/g, ' ')
    .trim()
    .split(' ');
}
